import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams, SearchDto } from "../../../assets/utils/lib";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import { QuestionDto, QuestionViewDto } from "../../dto";

export class QuestionClient extends BaseClient {
    routes = ["questionnaire", "questionnaire"];

    async getQuestionAsync(id: string | undefined): Promise<QuestionDto> {
        const actions: string[] = ["GetQuestion"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: QuestionDto = await this.getAsync<QuestionDto>(actions, params);
        return result;
    }

    async getLookupsAsync(questionniareId?: string | undefined): Promise<{ questionTypes: LookupDto[]; sections: LookupDto[]; }> {
        const actions: string[] = ["GetQuestionLookups"];
        const params: ApiParams[] = [new ApiParams("questionniareId", questionniareId, true)];
        const result = await this.getAsync<{ sections: LookupDto[]; questionTypes: LookupDto[]; }>(actions, params);
        return result;
    }

    async deActivateQuestionAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateQuestion"];
        const params: ApiParams[] = [new ApiParams("communityid", id, true)];
        return await this.getAsync(actions, params);
    }

    async searchQuestionsAsync(payload: SearchDto | undefined): Promise<IPagedResult<QuestionViewDto>> {
        const actions: string[] = ["SearchQuestionnaireQuestion"];
        const result: IPagedResult<QuestionViewDto> = await this.postAsync<SearchDto, QuestionViewDto, IPagedResult<QuestionViewDto>>(actions, payload);
        return result;
    }

    async saveQuestionAsync(payload: QuestionDto | undefined): Promise<IActionResult<QuestionDto>> {
        const actions: string[] = ["SaveQuestion"];
        return await this.postAsync<QuestionDto>(actions, payload);
    }

    async deleteQuestionAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteQuestion"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        return await this.deleteAsync(actions, params);
    }
}
